export type EventIdempotencyAttempt = {
  fingerprint: string;
  key: string;
};

function stableStringify(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(",")}]`;
  }
  if (value && typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, entry]) => entry !== undefined)
      .sort(([left], [right]) => left.localeCompare(right));
    return `{${entries
      .map(([key, entry]) => `${JSON.stringify(key)}:${stableStringify(entry)}`)
      .join(",")}}`;
  }
  return JSON.stringify(value) ?? "null";
}

export function fingerprintEventCreatePayload(payload: object): string {
  const rest = { ...(payload as Record<string, unknown>) };
  delete rest.idempotencyKey;
  return stableStringify(rest);
}

export function claimEventIdempotencyKey(
  current: EventIdempotencyAttempt | null,
  fingerprint: string,
  createKey: () => string = () => crypto.randomUUID(),
): { attempt: EventIdempotencyAttempt; key: string } {
  if (current?.fingerprint === fingerprint) {
    return { attempt: current, key: current.key };
  }
  const attempt = { fingerprint, key: createKey() };
  return { attempt, key: attempt.key };
}
